import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';
import {useLocation} from 'react-router-dom';

import {urlPrefixed} from '../../../config';
import {useSelector} from '../../../state/hooks';
import type * as PanelBankSectionConfigTypes from '../../../state/views/panelBankSectionConfig/types';
import {nwToast} from '../../../state/workspaces/namedWorkspaceToast';
import {PanelCopyLinkMenuItem} from '../common/PanelCopyLinkMenuItem';
import {getSharePanelLink} from '../FullScreenPanel/fullScreenUtils';
import {usePanelContext} from '../PanelContextProvider';

/**
 * If we are trying to copy the link for a panel on a regular workspace, we need
 * to generate the full screen panel link to be copied.
 */
export const WorkspacePanelCopyLinkMenuItem = ({
  panelBankSectionConfigRef,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
}) => {
  const {panel, trackPanelControls} = usePanelContext();
  const location = useLocation();
  const panelBankSectionName = useSelector(state => {
    return state.views.parts[panelBankSectionConfigRef.type][
      panelBankSectionConfigRef.id
    ]?.name;
  });

  const onSelect = useCallback(() => {
    const sharePanelPath = getSharePanelLink(
      panel,
      panelBankSectionName,
      location
    );
    copyToClipboard(urlPrefixed(sharePanelPath));
    nwToast('Copied to clipboard');

    trackPanelControls({action: 'Panel link copied'});
  }, [panel, panelBankSectionName, location, trackPanelControls]);

  return <PanelCopyLinkMenuItem onSelect={onSelect} />;
};
